import { useMemo } from "react"

let globalID = 1
/**
 * Get a globally unique id
 *
 * @param {string} prefix Prefix for id
 * @returns {string}  Prefixed global id
 */
export default function useGlobalID(prefix?: string) {
    return useMemo(() => `${prefix || ""}${globalID++}`, [prefix])
}
